import { render } from "./PanelFooter.vue?vue&type=template&id=616391da&scoped=true"
import script from "./PanelFooter.vue?vue&type=script&lang=js"
export * from "./PanelFooter.vue?vue&type=script&lang=js"

import "./PanelFooter.vue?vue&type=style&index=0&id=616391da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616391da"],['__file',"src/scripts/common/sideBars/components/PanelFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "616391da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('616391da', __exports__)) {
    api.reload('616391da', __exports__)
  }
  
  module.hot.accept("./PanelFooter.vue?vue&type=template&id=616391da&scoped=true", () => {
    api.rerender('616391da', render)
  })

}


export default __exports__